.vaccination-submitted .vaccination.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=vaccination-add-edit.component-VGRTIWWH.css.map */
